import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  fillRule: "evenodd",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M12 4.485a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 1 0 0-16.5m-9.75 8.25a9.75 9.75 0 1 1 19.5 0 9.75 9.75 0 1 1-19.5 0m14.269-3.541a.75.75 0 0 1 .023 1.06l-5.75 6a.75.75 0 0 1-1.083 0l-2.25-2.348a.75.75 0 1 1 1.083-1.038l1.709 1.783 5.209-5.435a.75.75 0 0 1 1.06-.023z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const CheckCircleIcon = ForwardRef;